import MaterialButton from 'components/arc-core/MaterialButton'
import Modal from 'components/global/Modal'
import { Col, Row } from 'components/grid'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image'
import React from 'react'
import formatUpdatedAtDate from 'utils/formatUpdatedAtDate'

interface Props {
	images?: {
		updatedAt: string
		id: string
		gatsbyImageData: IGatsbyImageData
	}[]
}

const PacingGuide = ({ images }: Props) => {
	const [show, setShow] = React.useState(false)
	const handleClose = () => setShow(false)
	const handleShow = () => setShow(true)

	const data = useStaticQuery(graphql`
		query {
			contentfulModal(name: { eq: "Pacing Guide" }) {
				title
				description {
					description
				}
			}
		}
	`)

	const title = data.contentfulModal.title

	return (
		<>
			{images && (
				<>
					<MaterialButton onClick={handleShow} image={images[0].gatsbyImageData} title={title} />
					<Modal
						wide
						title={title}
						subTitle={images.length > 1 ? `Updated ${formatUpdatedAtDate(images[1].updatedAt)}` : `Updated ${formatUpdatedAtDate(images[0].updatedAt)}`}
						isOpen={show}
						handleClose={handleClose}
					>
						<Row>
							<Col>
								{images.length > 1 ? <GatsbyImage image={images[1].gatsbyImageData} alt={title} /> : <GatsbyImage image={images[0].gatsbyImageData} alt={title} />}
							</Col>
						</Row>
					</Modal>
				</>
			)}
		</>
	)
}

export default PacingGuide
